module.exports = __webpack_public_path__ + "img/20220821_invite_bonus.a99cd9f9.png";